import Api from '@/services/Api'

export default {
  nytmedlem (medlemsdata) {
    return Api().post('add-medlem', medlemsdata)
  },
  medlemsliste () {
    return Api().get('medlemsliste')
  },
  kontingentliste () {
    return Api().get('kontingentliste')
  },
  betalingsData () {
    return Api().get('betalingsdata')
  },
  getStats () {
    return Api().get('stats')
  },
  intiateKontingentBetaling (medlemsID) {
    return Api().get('kontingentbetaling', {
      params: {
        id: medlemsID
      }
    })
  },
  intiateKontingentBetalinger () {
    return Api().get('kontingentbetaling', {
      params: {
        all: 'yes'
      }
    })
  },
  activeMedlem (medlemsID) {
    return Api().get('active-medlem', {
      params: {
        id: medlemsID
      }
    })
  },
  getMedlemsdata (memberId) {
    return Api().get(`medlemsdata/${memberId}`)
  },
  deactivateMedlem (memberId) {
    return Api().post(`medlemsdata/${memberId}/deactivate`)
  },
  getBetalinger (memberId) {
    return Api().get(`medlemsdata/${memberId}/betalinger`)
  }
}
